import axios from "axios"
import { useCallback, useEffect, useState } from "react"

export default function useGraphs({sectionId, dataset = [], tickers = []}) {
    const [ graphsId, setdGraphsId ] = useState(null)

    const createCompetitiveGraph = useCallback(async (dataset, tickers) => {
        if(tickers.length && dataset.length){
            setdGraphsId(null)
            // const resJeson = await fetch('/api/createCompetingGraph',{
            //     method: 'post',
            //     headers: {'Content-Type': 'application/json'},
            //     body: JSON.stringify({dataset: dataset[0], tickers, sectionId})
            // })
            const resJson = await axios({
                method: 'post',
                url: '/api/createCompetingGraph',
                data: {dataset: dataset[0], tickers, sectionId}
            })
            const res = await resJson.data
            setdGraphsId(res.graphIds)
        }
    },[sectionId])

    useEffect(() => {
        sectionId && axios.get(`/api/getCompetitionGraphs?sectionId=${sectionId}`).then(res => res.data)
        .then(res => {res.length 
            ? setdGraphsId(res) 
            : (dataset.length && tickers.length && createCompetitiveGraph(dataset, tickers))
        })
        return () => {}
    }, [sectionId]) // eslint-disable-line

    return {
        createCompetitiveGraph,
        graphsId,
    }
}